import cn from 'classnames';

import { IUserResponse } from '@/redux/modules/auth/userMini';

import type { IChatbotMessage } from '../ChatbotProvider';
import { EMessageRole, useChatbot } from '../ChatbotProvider';
import ModelMessage from './ModelMessage/ModelMessage';
import UserMessage from './UserMessage/UserMessage';

export interface IChatbotMessageProps {
  message: IChatbotMessage;
  authenticatedUser: IUserResponse | null;
  index?: number;
}

const ChatbotMessage = () => {
  const { messages, authenticatedUser } = useChatbot();
  return (
    <div className={cn('flex flex-col p-4 gap-4')}>
      {messages.length > 0 &&
        messages.map((message, index) =>
          message.role === EMessageRole.USER ? (
            <UserMessage
              key={index}
              message={message}
              authenticatedUser={authenticatedUser}
              index={index}
            />
          ) : (
            <ModelMessage key={index} message={message} authenticatedUser={null} />
          ),
        )}
    </div>
  );
};

export default ChatbotMessage;
